import { useCallback } from 'react';
import { useLocation, matchPath } from 'react-router-dom';
import { useTenantCode } from 'utils/hooks/useTenantConfig';

export const useSelected = (): ((path: string) => boolean) => {
  const location = useLocation();
  const tenantCode = useTenantCode();

  const isSelected = useCallback(
    (path: string): boolean => !!matchPath(location.pathname, { path: `/${tenantCode}/${path}` }),
    [location.pathname, tenantCode]
  );

  return isSelected;
};
